import React from 'react'
import { Accordion, AccordionItem } from './Accordion'
import AddProject from 'Components/AddProject'
import OutsideClickHandler from 'react-outside-click-handler'
import styles from './MainProjectsStyles'
import { searchTeams } from 'Lib/SearchProjects'

export default function MainProjects(props) {
  const {
    teams, history, addingProject, activeProject, handleItemClick,
    searchProjectKeyword, onAddProjectStart, onAddProjectEnd
  } = props

  const filteredTeams = searchTeams(teams, searchProjectKeyword)

  return filteredTeams.map(team =>
    <Accordion teamName={team.name}
               key={team.id}
               addProjectButton={true}
               onAddProject={onAddProjectStart(team)}
               noOfProjects={team.projects.length}>
      <OutsideClickHandler onOutsideClick={onAddProjectEnd}>
        <AddProject
          history={history}
          shown={addingProject === team.id}
          teamId={team.id} />
      </OutsideClickHandler>
      {team.projects.map(project =>
        <AccordionItem
          key={project.id}
          title={project.title}
          active={activeProject.id === project.id}
          noOfVideos={project.videosCount}
          onClick={handleItemClick(project)} />
      )}
      { team.projects.length < 1 &&
        <div className={styles.addProjectMsg}>
          Add a project to upload videos.
        </div>
      }
    </Accordion>
  )
}



// WEBPACK FOOTER //
// ./src/Components/SideBarLeft/MainProjects.js